export default __webpack_public_path__ + "static/media/SAS Alert Tone 14.b9943d24.mp3";